export default __webpack_public_path__ + "static/media/seat.d1eff984.svg";